<template>
  <div>
    <h3 class="mb-2">Dashboard</h3>
    <hr>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-green">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-globe fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">PAGE VIEWS</div>
            <div class="stats-number">{{ stats.pageViews }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-blue">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-users fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">CUSTOMERS</div>
            <div class="stats-number">{{ stats.customers }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="widget widget-stats bg-gradient-purple">
          <div class="stats-icon stats-icon-lg"><i class="fa fa-cloud-download fa-fw"></i></div>
          <div class="stats-content">
            <div class="stats-title">DOWNLOADS</div>
            <div class="stats-number">{{ stats.downloads }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 p-0">
      <div class="note note-purple m-b-15" v-if="!products.length&&!isLoading">
        <p class="p-0 m-0">You don't have an approved App yet.</p>
      </div>
      <div class="panel" v-if="products.length">
        <div class="panel-heading bg-silver">
          <h4 class="panel-title">Apps Details</h4>
        </div>
        <div class="panel-body p-t-0">
          <div class="table-responsive">
            <table class="table table-striped m-b-0 table-valign-middle">
              <thead>
                <tr>
                  <th>App Name</th>
                  <th class="text-center"><span class="label bg-gradient-green">Total Page Views</span></th>
                  <th class="text-center"><span class="label bg-gradient-blue">Total Customers</span></th>
                  <th class="text-center"><span class="label bg-gradient-purple">Total Downloads</span></th>
                  <th width="1%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in products" :key="product._id">
                  <td>
                    <p>{{ product.name }}</p>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.pageViews }}</div>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.users }}</div>
                  </td>
                  <td>
                    <div class="text-center">{{ product.stats.downloads }}</div>
                  </td>
                  <td>
                    <div class="text-center">
                      <router-link :to="{ name: 'Product', params: { slug: product.slug }}" class="btn btn-sm btn-primary">View App</router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex'
const _ = require('lodash')
export default {
  components: {},
  name: 'DashboardDeveloper',
  data() {
    return {
      isLoading: true,
      stats: {
        pageViews: 0,
        customers: 0,
        downloads: 0
      },
      products: []
    }
  },
  created: function () {
    this.fetchData().then(
      products => {
        const productsWithUpdateVersion = this.populateProducts(products)
        productsWithUpdateVersion.forEach(productsUpdateSet => {
          productsUpdateSet[1].forEach((product, index) => {
            if (index === 0) this.products.push(product)
          })
        })
        this.getStatsAllApps(this.products)
        this.isLoading = false
      },
      () => { this.isLoading = false }
    )
  },
  computed: {
    ...Vuex.mapGetters(['currentUser'])
  },
  methods: {
    fetchData() {
      return this.$http
        .get('product/dev-approved-apps/').then(resp => { return resp.data })
    },
    populateProducts(products) {
      // TODO: change this groupBy by lodash way
      products = products.reduce((groups, item) => {
        const val = item['slugRef']
        groups[val] = groups[val] || []
        groups[val].push(item)
        return groups
      }, {})
      // Convert Object To Array and sort it by last update
      products = Object.keys(products)
        .map(key => {
          products[key] = _.orderBy(products[key], 'technicalDetails.update', 'desc')
          return [key, products[key]]
        })
      return products
    },
    getStatsAllApps(products) {
      products.forEach(product => {
        this.stats.pageViews += product.stats.pageViews
        this.stats.customers += product.stats.users
        this.stats.downloads += product.stats.downloads
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/developer/DashboardDeveloper.vue